import { FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import { preventFormDefault } from '@/modules/common/utils/preventFormDefault.ts';
import { useAdminUpdateEntityStatus } from '@/modules/admin-dashboard/queries/entities.tsx';
import { Button, ModalContentWrapper, TextInputField } from 'ui';
import { EntityStatus, UpdateEntityStatusRequest } from 'api';

const validationSchema = yup.object({
  entity_application_rejection_reason: yup.string().trim().required('Reject reason is required'),
});

const initialValues = {
  id: 0,
  status: EntityStatus.EntityUnsuccessfull,
  entity_application_rejection_reason: '',
};

export interface AdminRejectentiytModalProps extends Pick<UpdateEntityStatusRequest, 'id'> {
  open: boolean;
  onClose: () => void;
}

export const AdminRejectEntityModal = ({ open, onClose, id }: AdminRejectentiytModalProps) => {
  const formik = useFormik<UpdateEntityStatusRequest>({
    initialValues: {
      ...initialValues,
      id,
    },
    validateOnBlur: false,
    validateOnChange: false,
    validateOnMount: false,
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      await rejectEntity(values);
      resetForm();
      onClose();
    },
    enableReinitialize: true,
  });

  const { mutateAsync: rejectEntity } = useAdminUpdateEntityStatus({ setErrors: formik.setErrors });

  const handleCloseModalWithResetForm = () => {
    formik.resetForm();
    onClose();
  };

  return (
    <ModalContentWrapper
      open={open}
      title="Rejection reason"
      onClose={handleCloseModalWithResetForm}
    >
      <FormikProvider value={formik}>
        <form className="w-full flex flex-col space-y-10" onSubmit={preventFormDefault}>
          <div className="w-full flex flex-col space-y-8">
            <TextInputField
              name="entity_application_rejection_reason"
              placeholder="Some reason..."
              textarea
            />
          </div>
          <Button onClick={formik.submitForm} loading={formik.isSubmitting}>
            Reject
          </Button>
        </form>
      </FormikProvider>
    </ModalContentWrapper>
  );
};
